"use client";

export function isMac(): boolean {
  if ("navigator" in globalThis) {
    return globalThis.navigator.userAgent.toLowerCase().includes("mac");
  }
  return false;
}
